import on from '../util/elements/on'
import destroys from '../util/elements/destroys'
import { toDP } from '../util/math/graphing'
import timelineFactory from '../util/async/timelineFactory'

let i = 0

export default function widgetIncrementer(Site, $) {
  Site.widget('incrementer', {
    _create() {
      this.index = i++
      destroys(this)
      const resetTimeline = timelineFactory()

      this.input = this.element.find('input[type="number"]')
      this.increments = this.element.find('.incrementer div')
      this.label = this.element.find('.copy--label')

      const step = this.input.attr('step')
      this.step = Number(step)
      this.dp = countDecimals(step)
      this.increase = 0

      this.min = Number(this.input.attr('min'))
      this.max = Number(this.input.attr('max'))

      const doChange = e => {
        const up = $(e.currentTarget).is('.up')
        const val = this.input.val()

        let newVal

        if (up) {
          newVal = toDP(Number(val) + this.step * this.increased(), this.dp)
        } else {
          newVal = toDP(Number(val) - this.step * this.increased(), this.dp)
        }

        if (typeof this.min === 'number' && !isNaN(this.min)) {
          newVal = Math.max(this.min, newVal)
        }

        if (typeof this.max === 'number' && !isNaN(this.max)) {
          newVal = Math.min(this.max, newVal)
        }

        this.input.val(newVal)

        this.updateLabel(newVal)

        this.input.trigger('input')
      }

      const onClick = on(this.increments, 'click', e => {
        resetTimeline()
        e.preventDefault()
        doChange(e)
        console.log('CLICK')
        this.input.trigger('blur')
      })

      const onStart = on(this.increments, 'mousedown touchstart', async e => {
        const waitFor = resetTimeline()

        await waitFor(600)

        this.started = true
        this.interval = setInterval(() => doChange(e), 90)
        this.increaser = setInterval(() => this.increase++, 500)
      })

      const onEnd = on($(window), 'mouseup touchend', e => {
        resetTimeline()
        clearInterval(this.interval)
        clearInterval(this.increaser)

        if (this.started) {
          e.preventDefault()
          this.started = false
          this.input.trigger('blur')
          this.increase = 0
        }
      })

      const onFocusLeave = on(this.input, 'blur', e => {
        const el = $(e.target)
        // Val can be a string. Lets just leave it as ==
        if (el.val() == 0) {
          el.val('')
        }
      })

      this.destroys(onClick, onStart, onFocusLeave, onEnd, () => {
        i = 0
      })
    },
    increased(step) {
      return Math.min(Math.max(1, this.increase - 3), 20)
    },
    updateLabel(newVal) {
      if (Number(newVal) === 1 && !this.lastWasSingle) {
        this.label.text(this.options.single)
        this.lastWasSingle = true
      } else {
        if (this.lastWasSingle) {
          this.label.text(this.options.plural)
        }
        this.lastWasSingle = false
      }
    },
  })
}

function countDecimals(value) {
  if (value % 1 !== 0) {
    return value.toString().split('.')[1].length
  }
  return 0
}
